<script>
import he from "he";
export default {
  name: "RecetteExtrait",

  props: {
    cpt: {
      type: Object,
    },
    dataJson: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    decode(string) {
      if (string) {
        return he.decode(string);
      }
      return false;
    },
  },
};
</script>

<template>
  <div>
    <div class="img-container">
      <div class="img-container">
        <template v-if="cpt.acf.image_pour_la_card">
          <a :href="cpt.link"
            ><img
              :src="cpt.acf.image_pour_la_card.sizes['image-principale-blog']"
              alt=""
          /></a>
        </template>
        <template v-else>
          <a :href="cpt.link"><img :src="cpt.thumbnail" alt="" /></a>
        </template>
      </div>
    </div>
    <div class="terms-container">
      <template v-if="cpt.acf.nouvelle_recette">
        <div class="term-wrapper">
          <p v-if="cpt.acf.nouvelle_recette" class="nouvelle_recette">
            {{ decode(dataJson.texte_bandeau_nouveau) }}
          </p>
        </div>
      </template>
      <template v-for="(taxo, indexTaxo) in cpt.terms" :key="indexTaxo">
        <div
          v-for="(term, index) in taxo"
          :key="term"
          :class="'term-wrapper ' + indexTaxo"
        >
          <span :class="'term term-' + index">
            {{ decode(term) }}
          </span>
        </div>
      </template>

      <template v-if="cpt.acf.champ_libre">
        <span v-if="cpt.acf.champ_libre" class="term term-libre">
          {{ decode(cpt.acf.champ_libre) }}
        </span>
      </template>
    </div>
    <h3>
      <a :href="cpt.permalink" class="lien-telechargement">{{
        decode(cpt.title)
      }}</a>
    </h3>
    <!-- 
    <p v-if="cpt.acf.description_extrait_de_la_page" class="desc-page">
      {{ decode(cpt.acf.description_extrait_de_la_page) }}
    </p> -->

    <div class="buttons-extrait">
      <p v-if="cpt.permalink" class="cta_center">
        <a :href="cpt.permalink"
          ><span>{{ decode(dataJson.texte_en_savoir_plus) }}</span>
        </a>
      </p>
    </div>
  </div>
</template>
<style></style>
